import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useGlobalSpinnerActionsContext } from "../../../../Context/GlobalSpinnerContext";
import tabsActions from "../../../../Actions/TabsActions";
import { useLanguageContext } from "../../../../Context/LanguageContext";
import SummarizeIcon from "@mui/icons-material/Summarize";
import tabsStore from "../../../../Stores/TabsStore";
import tabsConstants from "../../../../Constants/TabsConstants";
export default function OrderReportGenerator({ selectedItemId }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [pruefbericht, setPruefbericht] = useState(null);
  const PruefberichtEvent = () => {
    setGlobalSpinner(true);

    tabsActions.pruefberichtGenerieren(selectedItemId);
  };

  useEffect(() => {
    if (pruefbericht !== null && pruefbericht !== undefined) {
      const url = window.URL.createObjectURL(pruefbericht);
      let a = document.createElement("a");

      a.href = url;
      a.download = "B_Pruefbericht.pdf";
      a.click();
    }

    //  return ()=>{setPruefbericht(null);}
  }, [pruefbericht]);

  useEffect(() => {
    function updateData() {
      var _details = tabsStore.getResult();
      setPruefbericht(_details);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS,
      updateData
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS,
        updateData
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var _details = tabsStore.getResult();
      setPruefbericht(_details);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE,
      updateData
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE,
        updateData
      );
    };
  }, []);

  return (
    <Button
      variant="contained"
      className="gridTableButton gridTableButtonStyle"
      style={{ marginLeft: 8 }}
      onClick={PruefberichtEvent}
      startIcon={<SummarizeIcon />}
      aria-hidden={false}
    >
      {localization.report}
    </Button>
  );
}
